angular.
module("dx.webapp.jobs").
controller("DxJobsViewController", function JobsRouteController(
	$routeParams,
	$timeout,
	$scope,
	$location,

	DX_URLS,
	dxApi,
	RoleTypeEnum,
	dxSession,
	NodeRepository,
	DX_JOB_TYPE,
	DxJob,
	DX_JOB_STATUS
) {
	"use strict";

	var jobIdParam = parseInt($routeParams.jobId, 10);

	var self = this;

	self.Urls = DX_URLS;
	self.RoleTypeEnum = RoleTypeEnum;
	self.DX_JOB_TYPE = DX_JOB_TYPE;

	self.role = dxSession.getRole();
	self.loading = true;

	self.startedBy = "";

	var refreshTimeout = null;
	var scopeDestroyed = false;

	self.logUrl = function logUrl(project, jobId) {
		if (project === "digiexam-test") {
			return "#";
		}

		var base = "https://console.cloud.google.com/logs/viewer";
		var queryString = "?project=" + project + "&resource=gae_app%2Fmodule_id%2Fdefault&logName=projects%2F" + project + "%2Flogs%2Fappengine.googleapis.com%252Frequest_log&filters=querystring:jobId%3D" + jobId;
		return base + queryString;
	};

	self.taskQueueUrl = function taskQueueUrl(project, taskQueueName) {
		if (project === "digiexam-test") {
			return "http://localhost:8000/taskqueue/queue/" + taskQueueName;
		}

		return "https://console.cloud.google.com/cloudtasks/queue/" + taskQueueName + "?project=" + project;
	};

	self.navigateToJobList = function navigateToJobList() {
		$location.path(self.Urls.get("jobsList"));
	};

	function onJobLoadSuccess(response) {
		self.loading = false;
		self.job = new DxJob(response.data);

		if (self.role.roleType === self.RoleTypeEnum.MASTER) {
			dxApi.v1.users.get([self.job.userId], null).then(function onLoadSuccess(userRespnse) {
				var user = userRespnse.data[0];
				self.startedBy = user.firstName + " " + user.lastName;
			});
		}

		if (!self.node && self.job.organizationId) {
			NodeRepository.load(self.job.organizationId).then(function onNodeLoadSuccess(node) {
				self.node = node;
			});
		}

		if (self.job.status !== DX_JOB_STATUS.DONE && !scopeDestroyed) {
			refreshTimeout = $timeout(function reloadJob() {
				dxApi.v1.jobs.get(jobIdParam).then(onJobLoadSuccess, onJobLoadFail);
			}, 1500);
		}
	}

	function onJobLoadFail(response) {
		self.loading = false;
		self.error = response.data;
	}


	$scope.$on("$destroy", function onScopeDestroy() {
		scopeDestroyed = true;

		if (refreshTimeout) {
			$timeout.cancel(refreshTimeout);
		}
	});

	dxApi.v1.jobs.get(jobIdParam).then(onJobLoadSuccess, onJobLoadFail);
});
